import React, { useEffect, useState } from "react";
import TableHeading from "../../Components/common/table/Tableheading";
import TableData from "../../Components/common/table/TableData";
import { showData } from "../../Utils/APIs/commonShowAPI";
const InstallerList = () => {
  const headingList = [
    "Sr. No.",
    "name",
    "contact",
    "state",
    "district",
    "Account holder",
    "IFSC",
    "Account No",
    "bank name",
  ];
  const key = [
    "name",
    "contact",
    "state",
    "district",
    "accountHolderName",
    "IFSC_code",
    "accountNumber",
    "bankName",
  ];
  const [installerList, setInstallerList] = useState([]);
  const fetchList = async () => {
    await showData("installer/getInstallerList", setInstallerList);
  };
  useEffect(() => {
    fetchList();
  }, []);
  return (
    <div className="w-full h-full flex flex-col">
      <div className="mainHeading">
        <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50  rounded-lg">
          I<span className="text-lg">NSTALLER</span> L
          <span className="text-lg">IST</span>
        </h1>
      </div>
      <div className="h-full flex justify-center text-center w-full overflow-auto">
        <table >
          <TableHeading list={headingList} />
          <TableData keyList={key} dataList={installerList} />
        </table>
      </div>
    </div>
  );
};

export default InstallerList;
